import { EventApi } from 'api/ApiHelper';
import { AxiosRequestConfig } from 'axios';
import { eventsQueryKey } from 'queries/events/queryKey';
import { QueryClient, useQuery } from '@tanstack/react-query';

export const useGetEventQuery = (eventId: number, ignoreAccessible: boolean) =>
  useQuery({ queryKey: eventsQueryKey.event(eventId), queryFn: () => EventApi.getEvent(eventId, ignoreAccessible) });

export const prefetchEventQuery = async (
  queryClient: QueryClient,
  options: AxiosRequestConfig,
  eventId: number,
  ignoreAccessible: boolean,
) =>
  queryClient.prefetchQuery({
    queryKey: eventsQueryKey.event(eventId),
    queryFn: () => EventApi.getEvent(eventId, ignoreAccessible, options),
  });
